import axios from "axios";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

export default function Support() {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const token = localStorage.getItem("token");
  const { userData } = useContext(UserDataContext);
  const project = localStorage.getItem("currentProjectID");

  async function getDropdownOptions() {
    const userRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/tickets/${project}`,
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setDropdownOptions(userRes.data);
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "titel",
        header: "Titel",
        enableHiding: false,
      },
      {
        accessorKey: "status",
        header: "Status",
        enableHiding: false,
      },
      {
        accessorKey: "priority",
        header: "Priorität",
        enableHiding: false,
      },
      {
        accessorKey: "creator.name",
        header: "Ersteller",
        enableHiding: false,
      },
      {
        accessorKey: "createDate",
        header: "Erstellt am",
        enableHiding: false,
      },
      {
        accessorKey: "_id",
        header: "Optionen",
        enableHiding: false,
        Cell: ({ cell }) => (
          <>
            {" "}
            <Link to={`/support/${cell.getValue()}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline-block h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </Link>
          </>
        ),
      },
    ],
    []
  );

  let table = useMaterialReactTable({
    columns,
    data: dropdownOptions,
    localization: MRT_Localization_DE,
    initialState: {
      columnOrder: [
        "titel",
        "status",
        "priority",
        "creator.name",
        "createDate",
        "_id",
      ],
    },
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  useEffect(() => {
    getDropdownOptions();
  }, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Support Center
          </h3>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          <Link
            to="/support/new"
            className="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6 mr-3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
              />
            </svg>
            Ticket erstellen
          </Link>
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5 border-b border-gray-200 shadow  w-full sm:rounded-lg"></div>
      <MaterialReactTable table={table} />
    </>
  );
}
